export default "__VITE_ASSET__mKQ582vg__"